module.exports = __webpack_public_path__ + "988a490657a0cd2a005de969b2b784c2.MP3";